import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const EnergyBandSales = () => {
  const navigate = useNavigate();
  const [showQuantityModal, setShowQuantityModal] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const unitPrice = 6500; // BDT

  const handleBuyNow = () => {
    setShowQuantityModal(true);
  };

  const handleQuantityConfirm = () => {
    const totalAmount = quantity * unitPrice;
    navigate('/payment', { state: { amount: totalAmount } });
  };

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value) || 1;
    setQuantity(Math.max(1, value));
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-20 pb-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={() => navigate('/products')}
            className="flex items-center text-gray-600 hover:text-gray-800 mb-4 transition-colors"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Back to Products
          </button>
          <h1 className="text-4xl font-bold text-gray-900">EnergyBand</h1>
          <p className="text-xl text-gray-600 mt-2">Your Health Companion</p>
        </div>

        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="flex flex-col">
            {/* Product Image - Full Width */}
            <div className="w-full bg-gray-50 overflow-hidden">
              <img
                src="https://magicverse-public.s3.us-east-1.amazonaws.com/semionhealth/product_landing_img_bengali_v2.jpeg"
                alt="EnergyBand Health Bracelet"
                className="w-full h-auto object-cover"
                onError={(e) => {
                  e.target.src = '/android/playstoreAssets/bandMainImage.png';
                }}
              />
            </div>

            {/* Product Details - Below Image */}
            <div className="flex flex-col p-8">
              {/* Buy Button */}
              <div className="mb-6">
                <button
                  onClick={handleBuyNow}
                  className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2 shadow-md hover:shadow-lg"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                    />
                  </svg>
                  <span>Buy Now</span>
                </button>
                <p className="text-sm text-gray-500 text-center mt-3">
                  Free shipping on orders above ৳50
                </p>
                {showQuantityModal && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
                      <h3 className="text-xl font-semibold text-gray-900 mb-4">
                        Select Quantity
                      </h3>
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Quantity
                        </label>
                        <input
                          type="number"
                          min="1"
                          value={quantity}
                          onChange={handleQuantityChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        />
                      </div>
                      <div className="mb-4 p-4 bg-gray-50 rounded-lg">
                        <div className="flex justify-between items-center mb-2">
                          <span className="text-gray-600">Unit Price:</span>
                          <span className="font-semibold text-gray-900">৳{unitPrice.toLocaleString()}</span>
                        </div>
                        <div className="flex justify-between items-center mb-2">
                          <span className="text-gray-600">Quantity:</span>
                          <span className="font-semibold text-gray-900">{quantity}</span>
                        </div>
                        <div className="border-t border-gray-300 pt-2 mt-2 flex justify-between items-center">
                          <span className="text-lg font-bold text-gray-900">Total:</span>
                          <span className="text-lg font-bold text-green-600">
                            ৳{(quantity * unitPrice).toLocaleString()}
                          </span>
                        </div>
                      </div>
                      <div className="flex gap-3">
                        <button
                          onClick={() => setShowQuantityModal(false)}
                          className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleQuantityConfirm}
                          className="flex-1 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors"
                        >
                          Proceed to Payment
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="mb-6">
                <h2 className="text-3xl font-semibold text-gray-900 mb-4">
                  EnergyBand Health Bracelet
                </h2>
                <div className="flex items-center mb-4">
                  <div className="flex text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <svg
                        key={i}
                        className="w-5 h-5 fill-current"
                        viewBox="0 0 20 20"
                      >
                        <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                      </svg>
                    ))}
                  </div>
                  <span className="ml-2 text-gray-600">(4.5/5)</span>
                </div>
              </div>

              {/* Product Description */}
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  Product Description
                </h3>
                <div className="text-gray-700 space-y-3">
                  <p>
                    The EnergyBand is a state-of-the-art health monitoring bracelet designed to help you track and improve your wellness. With advanced sensors and seamless integration with the Semion Health app, it provides comprehensive health insights right on your wrist.
                  </p>
                  <div className="mt-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Accompanying App: SemionHealth</h4>
                    <p className="text-gray-700 mb-2">
                      Download the SemionHealth app to unlock the full potential of your EnergyBand. Monitor your health trends, consult with expert doctors, and get personalized health insights.
                    </p>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.semion.semionhealth"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold transition-colors"
                    >
                      <svg
                        className="w-5 h-5 mr-2"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                      </svg>
                      Download on Google Play
                    </a>
                  </div>
                  <div className="mt-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Key Features:</h4>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                      <li>24/7 Heart Rate Monitoring</li>
                      <li>Heart Rate Variability (HRV) Tracking</li>
                      <li>Blood Pressure Measurement</li>
                      <li>Stress Level Monitoring</li>
                      <li>Step Counter & Activity Tracking</li>
                      <li>Distance & Calorie Tracking</li>
                      <li>Sleep Quality Analysis</li>
                      <li>Real-time Health Alerts</li>
                      <li>Long Battery Life (up to 7 days)</li>
                      <li>Water Resistant Design</li>
                    </ul>
                  </div>
                  <div className="mt-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Why Choose EnergyBand?</h4>
                    <p className="text-gray-700">
                      The EnergyBand seamlessly integrates with the Semion Health platform, providing you with detailed health analytics, personalized recommendations, and the ability to share your health data with healthcare providers. Take control of your wellness journey with continuous, accurate health monitoring.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Information Section */}
          <div className="border-t border-gray-200 p-8 bg-gray-50">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <svg
                    className="w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">1 Year Warranty</h4>
                <p className="text-sm text-gray-600">Full manufacturer warranty</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <svg
                    className="w-6 h-6 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                    />
                  </svg>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">Free Shipping</h4>
                <p className="text-sm text-gray-600">On orders above $50</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <svg
                    className="w-6 h-6 text-purple-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">24/7 Support</h4>
                <p className="text-sm text-gray-600">Dedicated customer service</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnergyBandSales;

